module.exports = {
  i18n: {
    locales: ['en', 'ja-jp', 'en-jp'],
    defaultLocale: 'en',
    localeDetection: false,
  },
}
